import React from "react";

import {
  Route,
  Redirect
} from "react-router-dom";

import { withCookies } from 'react-cookie';
import {ROUTES, STUDIO_SESSION_COOKIE_DEV, STUDIO_SESSION_COOKIE_PROD} from "../utils/constants";

const PrivateRoute = function({component: Component,...rest}) {
  let renderable = function(props) {
    if (rest.cookies.get(STUDIO_SESSION_COOKIE_DEV) || rest.cookies.get(STUDIO_SESSION_COOKIE_PROD)) {
      return <Component {...props}/>;
    } else {
      return <Redirect to={{pathname: ROUTES.AUTH,state: {from: props.location}}}/>
    }
  }
  return (
    <Route
      {...rest}
      render = {renderable}
    />
  )
};

export default withCookies(PrivateRoute);
